import React from 'react';
import Suggestions from 'design-system/suggestions/Suggestions';
const SUGGESTIONS_DATA = [
    { name: 'Mortgage' },
    { name: 'Home' },
    { name: 'Gold' },
    { name: 'Shares' },
    { name: 'Golf' },
    { name: 'Jewellery' },
    { name: 'Holiday' },
    { name: 'Business' },
    { name: 'Wedding' },
    { name: 'Savings' },
    { name: 'Credit' },
    { name: 'Emergency' },
    { name: 'Family' },
    { name: 'Retirement' },
    { name: 'Medical' },
];
const SmartRuleNameSuggestions = ({ name, handleSuggestionPress, suggestedData, }) => (<Suggestions title="Suggestions" data={SUGGESTIONS_DATA} name={name} handleSuggestionPress={handleSuggestionPress} suggestedData={suggestedData}/>);
export default SmartRuleNameSuggestions;
